export const frecuencyValues = {
  one: 'one',
  everyTime: 'everyTime',
};

export const audienceValues = {
  registered: 'registered',
  public: 'public',
};
